export default __webpack_public_path__ + "static/media/architecture1Chi.6371a253.jpg";